export const PATCH_ORDER = 'PATCH_ORDER'
export const PATCH_ORDER_SUCCEEDED = 'PATCH_ORDER_SUCCEEDED'
export const PATCH_ORDER_FAILED = 'PATCH_ORDER_FAILED'

export const UPDATE_USER_NOTES = 'UPDATE_USER_NOTES'
export const UPDATE_USER_NOTES_SUCCEEDED = 'UPDATE_USER_NOTES_SUCCEEDED'
export const UPDATE_USER_NOTES_FAILED = 'UPDATE_USER_NOTES_FAILED'

export const patchOrder = (orderId, attributes) => ({
  type: PATCH_ORDER,
  payload: { orderId, attributes },
})

export const patchOrderSucceeded = (payload = {}) => ({
  type: PATCH_ORDER_SUCCEEDED,
  payload,
})

export const patchOrderFailed = (payload = {}) => ({
  type: PATCH_ORDER_FAILED,
  payload,
})

export const updateUserNotes = (orderId, userNotes) => ({
  type: UPDATE_USER_NOTES,
  payload: { orderId, userNotes },
})

export const updateUserNotesSucceeded = (payload = {}) => ({
  type: UPDATE_USER_NOTES_SUCCEEDED,
  payload,
})

export const updateUserNotesFailed = (payload = {}) => ({
  type: UPDATE_USER_NOTES_FAILED,
  payload,
})
